// Setter gaps (spec §06.7, §02.j, UAT-54): per-project WhatsApp follow-up settings and the status of the media/language
// components. Schemas in api-follow-up.ts and api-media-capabilities.ts. Shared by the WhatsApp and calls modules.
import * as F from './api-follow-up.js';
import * as M from './api-media-capabilities.js';
import { IdParam, route, W } from './route-def.js';

export const followUpRoutes = {
  getProjectFollowUp: route({
    method: 'GET', path: '/workspaces/:workspaceId/projects/:projectId/follow-up', summary: 'Seguimiento por WhatsApp del proyecto: ventana por vencer y compromisos (§06.7, §02.j)', tag: 'projects',
    minRole: 'advisor', params: W({ projectId: IdParam }), response: F.ProjectFollowUpSettingsSchema,
  }),
  putProjectFollowUp: route({
    method: 'PUT', path: '/workspaces/:workspaceId/projects/:projectId/follow-up', summary: 'Guardar el seguimiento por WhatsApp del proyecto (auditado)', tag: 'projects',
    minRole: 'admin', params: W({ projectId: IdParam }), body: F.PutProjectFollowUpSchema, response: F.ProjectFollowUpSettingsSchema,
  }),
  getProjectMediaCapabilities: route({
    method: 'GET', path: '/workspaces/:workspaceId/projects/:projectId/media-capabilities', summary: 'Componentes de medios e idioma del proyecto: configurado, degradado o no disponible (UAT-54)', tag: 'projects',
    minRole: 'advisor', params: W({ projectId: IdParam }), response: M.ProjectMediaCapabilitiesSchema,
  }),
} as const;
